<template>
  <div class="page-container">
    <PageHeader title="商户订单" show-breadcrumb>
      <template #actions>
        <el-button type="warning" icon="el-icon-download" size="small" :loading="exporting" @click="handleExport">导出 Excel</el-button>
      </template>
    </PageHeader>

    <SearchPanel>
      <el-input v-model.trim="query.aosOrderNo" placeholder="订单号" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.aosPhone" placeholder="用户手机号" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.createuserphone" placeholder="核销人手机号" clearable size="small" @keyup.enter.native="handleSearch" />
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="订单列表">
      <el-table :data="list" v-loading="loading" size="small" stripe border>
        <el-table-column type="index" label="序号" width="90" align="center" />
        <el-table-column prop="aosOrderNo" label="订单号" min-width="200" show-overflow-tooltip />
        <el-table-column prop="aosPhone" label="用户手机号" width="140" />
        <el-table-column prop="createusershop" label="核销商户" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createusername" label="核销人" width="110" />
        <el-table-column prop="createuserphone" label="核销人手机" width="140" />
        <el-table-column prop="aosImages" label="核销图片" width="120" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="row.aosImages" type="text" size="mini" @click="showImages(row.aosImages)">查看</el-button>
            <span v-else class="text-muted">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="核销时间" width="200" />
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 图片预览弹窗 -->
    <el-dialog title="核销图片" :visible.sync="imageDialogVisible" width="700px">
      <div class="image-preview-list">
        <img v-for="(url, idx) in imageList" :key="idx" :src="url" class="image-preview-item" @click="previewImage(url)" />
        <div v-if="!imageList.length" class="text-muted" style="padding:20px;text-align:center;">暂无图片</div>
      </div>
    </el-dialog>

    <!-- 大图预览 -->
    <el-dialog :visible.sync="bigImageVisible" width="800px" :show-close="true" append-to-body>
      <img :src="bigImageUrl" style="width:100%" />
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getAjefOrderShopList, exportAjefOrderShop } from '@/api/api'

export default {
  name: 'OrderList',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      exporting: false,
      list: [],
      query: { aosOrderNo: '', aosPhone: '', createuserphone: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      imageDialogVisible: false,
      imageList: [],
      bigImageVisible: false,
      bigImageUrl: ''
    }
  },
  created () { this.fetchList() },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await getAjefOrderShopList({ ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize })
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { aosOrderNo: '', aosPhone: '', createuserphone: '' }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    // 解析图片字段并展示
    showImages (images) {
      try {
        const parsed = JSON.parse(images)
        this.imageList = Array.isArray(parsed) ? parsed : [images]
      } catch (e) {
        this.imageList = images ? [images] : []
      }
      this.imageDialogVisible = true
    },
    previewImage (url) {
      this.bigImageUrl = url
      this.bigImageVisible = true
    },
    async handleExport () {
      this.exporting = true
      try {
        await exportAjefOrderShop(this.query)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-preview-list { display: flex; flex-wrap: wrap; gap: 12px; }
.image-preview-item { width: 120px; height: 120px; object-fit: cover; border-radius: 6px; cursor: pointer; border: 1px solid #e2e8f0; transition: transform 0.2s;
  &:hover { transform: scale(1.05); }
}
</style>
